import { Component } from '@angular/core';
import {
  NavController,
  NavParams,
  ModalController,
  ToastController,
  AlertController
} from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { TiposDiasModalPage } from '../tipos-dias-modal/tipos-dias-modal';
import { ListPage } from '../../pages/list/list';


@Component({
  selector: 'page-config',
  templateUrl: 'config.html',
})
export class ConfigPage {

  tiposDias: any[] = [];
  cargandoTipos: boolean = false;
  errorTiposDias: string = '';

  bloqueado = false;
  pruebas = false;
  proponerIncidFaltaCierre = false;
  cargandoProponerIncid = false;
  guardandoProponerIncid = false;
  pdfDetalleExplicativo = false;
  cargandoPdfDetalle = false;
  guardandoPdfDetalle = false;
  // Estos nombres tambien los usa el bloque antiguo de correo de esta pantalla.
  cargando = false;
  guardando = false;
  guardandoResumen = false;
  enviarResumenEmail = false;
  resumenEmail = '';
  novedadPdfVista = false;
  private claveNovedadPdf = '';

  constructor(
    public variables: VariablesProvider,
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public funciones: FuncionesProvider
  ) {
  }

  ionViewWillEnter() {
    this.cargarModoPruebas();
    this.cargarConfiguracionProponerIncidencia();
    this.cargarTiposDias();
    this.cargarConfiguracionPdfDetalle();
    this.cargarResumenEmail();
    this.cargarEstadoNovedad();
  }

  private claveModoPruebas(): string {
    return 'config:modo-pruebas:' + (this.variables.CLIENTES_RAZSOCIAL || this.variables.emailoriginal || 'cuenta');
  }

  cargarModoPruebas() {
    const clave = this.claveModoPruebas();
    let guardado: string = null;
    try { guardado = localStorage.getItem(clave); } catch (e) { guardado = null; }
    if (guardado === '1' || guardado === '0') {
      this.variables.MODO = guardado === '1' ? 'pruebas' : 'real';
    }
    this.pruebas = this.variables.MODO !== 'real';
  }

  cargarConfiguracionProponerIncidencia() {
    this.cargandoProponerIncid = true;
    Promise.resolve(this.funciones.obtieneconfiguracion()).then((data: any) => {
      const fila: any = Array.isArray(data) ? (data[0] || {}) : (data || {});
      const valor = fila.PICADA_CIERRE_AUTO != null ? fila.PICADA_CIERRE_AUTO : fila.VALOR;
      this.proponerIncidFaltaCierre = String(valor) === '1' || valor === true || valor === 1;
    }).catch(error => {
      console.log('No se pudo cargar la configuraci&oacute;n de incidencias', error);
    }).then(() => { this.cargandoProponerIncid = false; });
  }

  onChangeProponerIncidFaltaCierre() {
    if (this.guardandoProponerIncid) { return; }
    const nuevoValor = !!this.proponerIncidFaltaCierre;
    this.guardandoProponerIncid = true;
    Promise.resolve(this.funciones.actualizaconfiguracion(nuevoValor ? 1 : 0)).then((data: any) => {
      const fila: any = Array.isArray(data) ? (data[0] || {}) : (data || {});
      if (fila.RESULTADO && String(fila.RESULTADO).toUpperCase() === 'ERROR') {
        throw new Error(fila.MENSAJE || 'No se pudo guardar la configuraci&oacute;n');
      }
      this.presentToast(nuevoValor ? 'Incidencia automatica activada' : 'Incidencia automatica desactivada');
    }).catch(error => {
      this.proponerIncidFaltaCierre = !nuevoValor;
      console.log('No se pudo guardar la configuraci&oacute;n de incidencias', error);
      this.presentToast('No se pudo guardar esta opcion');
    }).then(() => { this.guardandoProponerIncid = false; });
  }

  cargarResumenEmail() {
    this.cargando = true;
    Promise.resolve(this.funciones.obtieneResumenEmail()).then((data: any) => {
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { data = []; }
      }
      const fila = Array.isArray(data) ? (data[0] || {}) : (data || {});
      const activo = fila.ACTIVO != null ? fila.ACTIVO : fila.activo;
      const email = fila.EMAIL != null ? fila.EMAIL : fila.email;
      this.enviarResumenEmail = String(activo) === '1' || activo === true || activo === 1;
      this.resumenEmail = email || '';
    }).catch(error => {
      console.log('No se pudo cargar el resumen por correo', error);
    }).then(() => {
      this.cargando = false;
    });
  }

  onChangeEnviarResumenEmail() {
    if (this.guardandoResumen) { return; }
    this.guardarResumenEmail();
  }

  onBlurResumenEmail() {
    if (this.enviarResumenEmail && !this.guardandoResumen) {
      this.guardarResumenEmail();
    }
  }

  guardarResumenEmail() {
    this.guardandoResumen = true;
    Promise.resolve(this.funciones.actualizaResumenEmail(this.enviarResumenEmail ? 1 : 0, this.resumenEmail || ''))
      .then((data: any) => {
        const fila = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (fila.RESULTADO && String(fila.RESULTADO).toUpperCase() === 'ERROR') {
          throw new Error(fila.MENSAJE || 'No se pudo guardar el resumen');
        }
        this.presentToast('Configuración guardada');
      })
      .catch(error => {
        console.log('No se pudo guardar el resumen por correo', error);
        this.presentToast('No se pudo guardar el resumen por correo');
      })
      .then(() => {
        this.guardandoResumen = false;
      });
  }

  cargarEstadoNovedad(): void {
    this.claveNovedadPdf = 'novedad:pdf-detalle-explicativo:v1:' + (this.variables.CLIENTES_RAZSOCIAL || '');
    const vistaLocal = typeof localStorage !== 'undefined' && localStorage.getItem(this.claveNovedadPdf) === '1';
    this.novedadPdfVista = vistaLocal;
    if (vistaLocal || !this.variables.CLIENTES_RAZSOCIAL) { return; }

    Promise.resolve(this.funciones.obtieneEstadoNovedad('pdf-detalle-explicativo-v1')).then((data: any) => {
      const fila: any = Array.isArray(data) ? (data[0] || {}) : (data || {});
      const vistaServidor = String(fila.VISTA || fila.vista || '').toLowerCase() === '1' || fila.VISTA === true;
      this.novedadPdfVista = vistaServidor;
      if (vistaServidor && typeof localStorage !== 'undefined') {
        localStorage.setItem(this.claveNovedadPdf, '1');
      }
    }).catch(error => {
      // El servidor antiguo puede no tener todavía la tabla de novedades.
      console.log('No se pudo consultar el estado de la novedad', error);
    });
  }

  verNovedades(): void {
    this.alertCtrl.create({
      title: 'Novedades del panel',
      message: '<b>Detalle explicativo del informe mensual</b><br><br>' +
        'Al activar la opción correspondiente en Configuración, el PDF mensual incorpora una segunda página con las picadas, los tramos y la línea de tiempo de cada día. La primera página, los textos legales y las firmas se mantienen sin cambios.<br><br>' +
        '<small>Estado: ' + (this.novedadPdfVista ? 'vista' : 'pendiente de ver') + '</small>',
      buttons: ['Cerrar']
    }).present();
  }

  cargarConfiguracionPdfDetalle() {
    this.cargandoPdfDetalle = true;
    let respuesta: any;
    try {
      respuesta = this.funciones.obtieneConfiguracionPdfDetalle();
    } catch (e) {
      this.cargandoPdfDetalle = false;
      return;
    }
    Promise.resolve(respuesta).then(data => {
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { data = []; }
      }
      const fila = Array.isArray(data) ? (data[0] || {}) : (data || {});
      const valor = fila.PDF_DETALLE_EXPLICATIVO != null ? fila.PDF_DETALLE_EXPLICATIVO :
        (fila.pdf_detalle_explicativo != null ? fila.pdf_detalle_explicativo : fila.activo);
      this.pdfDetalleExplicativo = String(valor) === '1' || valor === true || valor === 1;
      this.variables.PDF_DETALLE_EXPLICATIVO = this.pdfDetalleExplicativo;
    }).catch(error => {
      console.log('No se pudo cargar la configuración del PDF detallado', error);
    }).then(() => {
      this.cargandoPdfDetalle = false;
    });
  }

  onChangePdfDetalle() {
    if (this.guardandoPdfDetalle) { return; }
    const nuevoValor = !!this.pdfDetalleExplicativo;
    const valorAnterior = !!this.variables.PDF_DETALLE_EXPLICATIVO;
    this.guardandoPdfDetalle = true;
    Promise.resolve(this.funciones.actualizaConfiguracionPdfDetalle(nuevoValor)).then(data => {
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { data = []; }
      }
      const fila = Array.isArray(data) ? (data[0] || {}) : (data || {});
      if (fila.RESULTADO && String(fila.RESULTADO).toUpperCase() === 'ERROR') {
        throw new Error(fila.MENSAJE || 'La API no ha guardado la opción.');
      }
      this.variables.PDF_DETALLE_EXPLICATIVO = nuevoValor;
      this.presentToast(nuevoValor ? 'PDF con detalle activado' : 'PDF con detalle desactivado');
    }).catch(error => {
      this.pdfDetalleExplicativo = valorAnterior;
      console.log('No se pudo guardar la configuración del PDF detallado', error);
      this.presentToast('No se pudo guardar esta opción');
    }).then(() => {
      this.guardandoPdfDetalle = false;
    });
  }

  cargarTiposDias() {
    this.cargandoTipos = true;
    this.errorTiposDias = '';
    this.tiposDias = [];

    let respuesta: any;

    try {
      respuesta = this.funciones.obtenerTiposDias();
    } catch (e) {
      this.errorCargaTipos(e);
      return;
    }

    /*
      Soporta las dos formas:
      - Observable: this.http.get(...).map(...)
      - Promise
    */

    if (respuesta && typeof respuesta.subscribe === 'function') {
      respuesta.subscribe(
        data => {
          this.procesarRespuestaTipos(data);
        },
        error => {
          this.errorCargaTipos(error);
        }
      );
    } else if (respuesta && typeof respuesta.then === 'function') {
      respuesta.then(
        data => {
          this.procesarRespuestaTipos(data);
        },
        error => {
          this.errorCargaTipos(error);
        }
      );
    } else {
      this.procesarRespuestaTipos(respuesta);
    }
  }


  // ===================================================
// OPCIÓN - MODO PRUEBAS
// ===================================================
openPage() {

  this.bloqueado = true;

  this.variables.MODO = (this.variables.MODO === 'real') ? 'pruebas' : 'real';

  if (this.variables.MODO == "pruebas") {
    this.pruebas = true;
  } else {
    this.pruebas = false;
  }

  try { localStorage.setItem(this.claveModoPruebas(), this.pruebas ? '1' : '0'); } catch (e) { }

  this.bloqueado = false;
}

  salir(){
    this.navCtrl.push(ListPage);
 }

  procesarRespuestaTipos(data: any) {
    this.cargandoTipos = false;

    if (!data) {
      this.tiposDias = [];
      return;
    }

    /*
      Por si PHP devuelve texto JSON en vez de objeto.
    */
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        this.tiposDias = [];
        return;
      }
    }

    let listado: any[] = [];

    /*
      Soporta varias respuestas posibles:
      [
        {...},
        {...}
      ]

      o

      {
        datos: [...]
      }

      o

      {
        data: [...]
      }

      o

      {
        tipos: [...]
      }
    */

    if (Array.isArray(data)) {
      listado = data;
    } else if (data.datos && Array.isArray(data.datos)) {
      listado = data.datos;
    } else if (data.data && Array.isArray(data.data)) {
      listado = data.data;
    } else if (data.tipos && Array.isArray(data.tipos)) {
      listado = data.tipos;
    } else {
      listado = [];
    }

    this.tiposDias = [];

    for (let i = 0; i < listado.length; i++) {
      let t = listado[i];

      let diasAnuales = this.valorNumero(t.dias_anuales || t.DIAS_ANUALES || t.dias || t.DIAS || 0);

this.tiposDias.push({
  id: t.id || t.ID || '',
  user: t.user || t.USER || '',
  codigo: t.codigo || t.CODIGO || '',
  nombre: t.nombre || t.NOMBRE || '',

  dias: diasAnuales,
  dias_anuales: diasAnuales,

  ilimitado: this.valorNumero(t.ilimitado || t.ILIMITADO || 0),
  descuenta_saldo: this.valorNumero(t.descuenta_saldo || t.DESCUENTA_SALDO || 1),
  visible_app: this.valorNumero(t.visible_app || t.VISIBLE_APP || 0),

  requiere_confirmacion: this.valorNumero(t.requiere_confirmacion || t.REQUIERE_CONFIRMACION || 0),
  activo: this.valorNumero(t.activo || t.ACTIVO || 1),
  color: t.color || t.COLOR || '#999999',
  orden: this.valorNumero(t.orden || t.ORDEN || 99)
});
    }

    this.ordenarTiposDias();
  }

  errorCargaTipos(error: any) {
    this.cargandoTipos = false;
    this.tiposDias = [];
    this.errorTiposDias = 'No se pudieron cargar los tipos de días';

    console.log('Error cargando tipos de días', error);

    this.presentToast('No se pudieron cargar los tipos de días');
  }

  ordenarTiposDias() {
    this.tiposDias.sort(function(a, b) {
      if (a.orden < b.orden) {
        return -1;
      }

      if (a.orden > b.orden) {
        return 1;
      }

      if (a.nombre < b.nombre) {
        return -1;
      }

      if (a.nombre > b.nombre) {
        return 1;
      }

      return 0;
    });
  }

  nuevoTipoDia() {

    let user = this.variables.CLIENTES_RAZSOCIAL;

    if (!user || user == '') {
      user = this.variables.emailoriginal;
    }

    let modal = this.modalCtrl.create(TiposDiasModalPage, {
      modo: 'nuevo',
      tipo: null,
      user: user
    });

    modal.onDidDismiss(data => {
      if (data && data.guardado == true) {
        this.cargarTiposDias();
      }
    });

    modal.present();
  }

  editarTipoDia(tipo: any) {
    if (!tipo) {
      return;
    }
  
    let copiaTipo = JSON.parse(JSON.stringify(tipo));
  
    let user = this.variables.CLIENTES_RAZSOCIAL;
  
    if (!user || user == '') {
      user = this.variables.emailoriginal;
    }
  
    let modal = this.modalCtrl.create(TiposDiasModalPage, {
      modo: 'editar',
      tipo: copiaTipo,
      user: user
    });
  
    modal.onDidDismiss(data => {
      if (data && data.guardado == true) {
        this.cargarTiposDias();
      }
    });
  
    modal.present();
  }

  confirmarEliminarTipo(tipo: any) {
    if (!tipo) {
      return;
    }

    let alert = this.alertCtrl.create({
      title: 'Eliminar tipo',
      message: '¿Quieres eliminar o desactivar "' + tipo.nombre + '"?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Desactivar',
          handler: () => {
            this.desactivarTipoDia(tipo);
          }
        }
      ]
    });

    alert.present();
  }

  desactivarTipoDia(tipo: any) {
  
  /*
    if (!tipo || !tipo.id) {
      return;
    }

    let respuesta: any;

    try {
      respuesta = this.funciones.desactivarTipoDia(tipo.id);
    } catch (e) {
      console.log('Error desactivando tipo', e);
      this.presentToast('No se pudo desactivar');
      return;
    }

    if (respuesta && typeof respuesta.subscribe === 'function') {
      respuesta.subscribe(
        data => {
          this.presentToast('Tipo desactivado');
          this.cargarTiposDias();
        },
        error => {
          console.log('Error desactivando tipo', error);
          this.presentToast('No se pudo desactivar');
        }
      );
    } else if (respuesta && typeof respuesta.then === 'function') {
      respuesta.then(
        data => {
          this.presentToast('Tipo desactivado');
          this.cargarTiposDias();
        },
        error => {
          console.log('Error desactivando tipo', error);
          this.presentToast('No se pudo desactivar');
        }
      );
    }
    */
  }

  valorNumero(valor: any): number {
    if (valor === null || valor === undefined || valor === '') {
      return 0;
    }

    let n = Number(valor);

    if (isNaN(n)) {
      return 0;
    }

    return n;
  }

  presentToast(mensaje: string) {
    let toast = this.toastCtrl.create({
      message: mensaje,
      duration: 2500,
      position: 'bottom'
    });

    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/config/config.ts